import { Component, OnInit, Output, EventEmitter, forwardRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Utility } from 'src/app/core/common';
import { JobService } from 'src/app/services/job.service';
import { UserService } from 'src/app/services/user.service';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { LocationComponent } from '../location/location.component';

type searchTypes = 'job' | 'seeker' | 'employer' | 'rtwad' | 'discussion' | 'resource' | 'news' | 'all';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SearchBoxComponent),
    multi: true,
  }]
})
export class SearchBoxComponent implements OnInit, ControlValueAccessor, OnDestroy {
  Utility = Utility;
  constructor(private router: Router, private route: ActivatedRoute,
    private userService: UserService, private store: Store) { }

  @Input() queryPlaceholder = 'چه کاری؟';
  @Input() locationPlaceholder = 'کجا؟';
  @Input() searchType: searchTypes = 'job';
  @Input() showFilters = false;
  @Input() showFilterBar = true;
  @Input() showLocation = true;
  @Input() navigateEnabled = true;
  @Input() compact = false;
  @Output('on-search') onSearch = new EventEmitter<any>();
  isAdmin = false;


  operators: any[] = [];
  @Input() wrapFilters = false;

  async ngOnInit() {
    this.value = Object.assign({}, this.route.snapshot.params, this.route.snapshot.queryParams);
    var user = this.store.selectSnapshot(state => state.auth.user);
    this.isAdmin = user?.Operator || user?.Karpasha;
    this.operators = [user];
    if (this.isAdmin)
      this.userService.karpashas$.subscribe(_ => this.operators = _);

    // setTimeout(() => document.querySelector('a.scroll-into-view')?.scrollIntoView({ behavior: 'smooth' }));
  }
  ngOnDestroy(): void { }

  @ViewChild('locationSelector') locationSelector: LocationComponent;
  @ViewChild('keywordSelector') keywordSelector: AutocompleteComponent;

  get locationString() {
    if (!this.location || (!this.location.City && !this.location.State))
      return 'سراسر کشور';
    if (!this.location.City) {
      if (this.location.State) return `استان ${this.location.State}`;
    } else return `${this.location.State}، ${this.location.City}`;
  }

  @Input('is-homepage') isHomePage: boolean;
  @Input() showPageLinks: boolean;

  pageLinks = [
    { title: 'استخدام', path: '/job' },
    { title: 'آماده به کار', path: '/ready-to-work', new: true },
    { title: 'تبادل‌ نظر', path: '/discussion' },
    { title: 'دوره‌آموزشی', path: '/resource/course' },
    { title: 'نمونه سوال', path: '/resource/exam' },
    { title: 'مقاله', path: '/resource/article' },
    { title: 'کتاب', path: '/resource/book' },
    { title: 'فایل و قالب', path: '/resource/template' },
    { title: 'نرم‌افزار', path: '/resource/software' },
    { title: 'اخبار استخدامی', path: '/news' },
    // { title: 'کارجو', path: '/employer/seekers' },
  ];

  location: any = {};
  _value: any = {};
  get value(): any { return this._value; }
  set value(val: any) {
    val = Utility.removeEmpty(val || {});
    if (!val.l && (val.state || val.city))
      val.l = Utility.join('،', val.state, val.city);
    this._value = val;
    this.location = Utility.getLocation(this._value.l);
    this.propagateChange(this._value);
  }

  search(type: string, value: any) {
    const params = this.value;

    if (type == 'keyword')
      params.q = value || undefined;
    if (type == 'location') {
      this.location = value;
      params.l = Utility.locationSearch(value.State, value.City) || undefined;
      params.state = value.state = value.State;
      params.city = value.city = value.City;
    }

    if (this.navigateEnabled) {
      if (!this.isHomePage) {
        switch (this.searchType) {
          case 'job':
            let urlParams = JobService.getSearchUrlParams(params);
            this.router.navigate(['/job', urlParams.params], { queryParams: urlParams.queryParams });
            break;
          case 'seeker':
            this.router.navigate([Utility.removeUndefined(params)], { relativeTo: this.route });
            break;
          case 'rtwad':
            const pathParams = Utility.removeUndefined({ q: params.q, l: params.l });
            this.router.navigate([pathParams], { relativeTo: this.route });
            break;
          default:
            this.router.navigate([Utility.removeUndefined({ q: params.q })], { relativeTo: this.route });
            break;
        }
      }
      else if (this.navigateEnabled && params.q && params.l) // Just for Homepage
        this.router.navigate(['/job', Utility.removeUndefined({ l: params.l, q: params.q })]);
    }
    else {
      this.onSearch.emit(params);
    }
  }

  writeValue(value: any): void {
    if (value) this.value = value;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void { }
  private propagateChange = (_: any) => { };

  get urlParams(): any { return JobService.getSearchUrlParams(this.value); }

  setFilter(key: string, val: string = undefined) {
    this.value[key] = val?.toString();
    var params = JobService.getSearchUrlParams(this.value);
    if (this.navigateEnabled)
      this.router.navigate(['/job', params.params], { queryParams: params.queryParams });
    else this.onSearch.emit(params);
  }
  removeFilter(key: string, val: string = undefined) {
    let filter: string = this.value[key];
    if (val && filter.split)
      filter = filter.split(',').filter(_ => _ != val).join(',');
    else
      filter = undefined;

    if (filter)
      this.value[key] = filter;
    else
      delete this.value[key];

    var params = JobService.getSearchUrlParams(this.value);
    if (this.navigateEnabled)
      this.router.navigate(['/job', params.params], { queryParams: params.queryParams });
    else this.onSearch.emit(params);
  }

}
